export default class Hero
{
  constructor(titles, contents, buttonContents, buttonUrl, image, type) 
  {
    // {} instead of array to support stringify
    this.titles = titles;
    this.contents = contents;
    this.buttonContents = buttonContents;

    this.buttonUrl = buttonUrl;
    this.image = image;
    this.type = type;
  }    

  isValid()
  {
    var result = true;

    for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; } // Titles
    if(result) for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; }; } // Contents
    if(result) for (const [key, value] of Object.entries(this.buttonContents)) { if(!value) { result = false; break; }; } // ButtonContents

    if(result) result = this.buttonUrl && this.image && this.type;
    
    return result;
  }
}